import {useEffect,useRef} from 'react';
import {X,UploadSimple} from '@phosphor-icons/react';
import Submit from '../pages/Submit';
export default function ContributionModal({onClose}) {
 const ref=useRef(null);
 useEffect(()=>{
  const dialog=ref.current, opener=document.activeElement, previous=document.body.style.overflow;
  dialog.showModal();document.body.style.overflow='hidden';
  return ()=>{dialog.close();document.body.style.overflow=previous;opener?.focus();};
 },[]);
 return <dialog ref={ref} className="sdx-contribution-dialog" aria-label="Contribute sustainability data"
 onCancel={event=>{event.preventDefault();onClose();}}>
 <div className="sdx-request-dialog-bar"><span><UploadSimple size={18}/> Contribute to SustainDex</span>
 <button type="button" onClick={onClose} aria-label="Close contribution form"><X size={20}/></button></div>
 <Submit embedded/>
 </dialog>;
}
